import serializeEvent from '../util/serializeEvent';

// ==============================================================
// this middleware queues payloads to the logger for handling
// ==============================================================

import getLogger from '../kinesis/QuizEventsLogger';
import { getActiveQuizSessionId } from '../selectors/quizSessions';
var eventLoggerMiddlewareCreator = function eventLoggerMiddlewareCreator() {
  var loggerFetch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLogger;
  var serializer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : serializeEvent;
  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var eventJSON = serializer(action, store);
        if (eventJSON) {
          var quizSessionId = getActiveQuizSessionId(store.getState());
          // This middleware sometimes gets used on pages without quiz sessions due to race conditions
          if (quizSessionId === null) {
            return result;
          }
          loggerFetch(quizSessionId).then(function (logger) {
            logger.enqueueEvent(eventJSON);
          });
        }
        return result;
      };
    };
  };
};
export default eventLoggerMiddlewareCreator;